module.exports = __webpack_public_path__ + "static/ghubd-3480db5eabd3ef35cf349caa44c5171e.png";